import { DateTime } from 'luxon';
// import { DateTime } from 'https://cdn.jsdelivr.net/npm/luxon@3.7.2/+esm'

const Utils = {
  // --------------------------------
  //  Parse a url and break it into resource, id and verb
  // --------------------------------
  parseRequestURL: () => {
    let url = location.hash.slice(1).toLowerCase() || "/";
   
  
    let request = {
      resource: null,
      id: null,
      verb: null,
      query: {},
    };

    let query = url.split("?");
    if (query && query.length > 0) {
      url = query[0];
      for (let index = 1; index < query.length; index++) {
        const element = query[index];
        const key = element.split('=')[0];
        const value = element.split('=')[1];

        request.query[key] = value;
      }
    }
    let r = url.split("/");
    request.resource = r[1];
    request.id = r[2];
    request.verb = r[3];

    return request;
  },

  // --------------------------------
  //  Simple sleep implementation
  // --------------------------------
  parseJwt: (token) => {
    if (!token) return {};
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  },
  sleep: (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
  currencyCode: (symbol) => {
    const currency = [
      { symbol: "€", id: "1", code: 'EUR' },
      { symbol: "L", id: "2", code: 'LEK' },
      { symbol: "$", id: "3", code: 'USD' },
      { symbol: "fr", id: "4", code: 'CHF' },
      { symbol: "£", id: "5", code: 'GBP' },
      { symbol: "д", id: "6", code: 'MKD' }
    ];

    return currency.some(c => c.symbol === symbol) ? currency.find(c => c.symbol === symbol).code : symbol;
  },
  getMatchMarket: (match) => {
    if (!match) return '';
    try {
      return match.split('|')[4];
    } catch (e) {
      return '';
    }
  },
  getMatchMarketOption: (match) => {
    if (!match) return '';
    try {
      return match.split('|')[2] + ' ';
    } catch (e) {
      return '';
    }
  },
  parseNumber: (value) => {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    if (typeof value !== 'string') return 0;

    const normalizedValue = value.replace(/,/g, '').trim();
    const parsedValue = Number(normalizedValue);

    return Number.isFinite(parsedValue) ? parsedValue : 0;
  },
  formatNumber: (value, currency, decimalPlaces) => {
    if (typeof value === 'string') {
      const normalizedValue = value.replace(/,/g, '').trim();
      value = parseFloat(normalizedValue);
    }
    if (typeof value !== 'number') return '';
    const options = {
      minimumFractionDigits: decimalPlaces ?? 2,
      maximumFractionDigits: decimalPlaces ?? 2
    };
    return value.toLocaleString('en-GB', options) + (currency ? ` ${currency}` : '');
  },
  formatDate: (game_date, game_time, format) => {
    if (!game_date || !game_time) return '';

    if (game_time.split(':').length < 3) {
      game_time += ':00';
    }

    const dt = DateTime.fromISO(`${game_date}T${game_time}`, {
      zone: 'Europe/Berlin'
    });

    if (!dt.isValid) return '';

    let formatter_format;

    if (format === 'dateOnly') {
      formatter_format = { year: 'numeric', month: '2-digit', day: '2-digit' };
    } else if (format === 'timeOnly') {
      formatter_format = { hour: '2-digit', minute: '2-digit' };
    } else if (format === 'fullTime') {
      formatter_format = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
    } else if (format === 'withoutYear') {
      formatter_format = { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
    } else {
      formatter_format = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
    }

    return new Intl.DateTimeFormat('en-GB', {
      ...formatter_format,
      hour12: false,
    }).format(dt.toJSDate()).replace(/\//g, '-');
  },
  paramsToObject: (entries) => {
    const result = {}
    for(const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }
};

export default Utils;
